<template>

    <div id="Home">
        <!--     
            <v-parallax
            height="630"
        > -->
        <!-- 
            :src="require('../../src/assets/images/embalatge-packetgrup.jpg')" -->
          <!--     cycle -->
        <v-carousel 
            class="carousel-home"
            hide-delimiters
            cycle
            height="100vh"
            :show-arrows="false"
        >
            <v-carousel-item
                v-for="(item,i) in items"
                :key="i"
                height="100vh"
                :src="item.src"
                :srcset="item.srcset"
                reverse-transition="fade-transition"
                transition="fade-transition"
                
            ></v-carousel-item>
        </v-carousel>
        <div class="container container-home">
            <v-row align="center">
                <v-col cols="12">
                    <div class="box-title-home">
                        <div class="box-inner-title">
                            <h1 align="center" class="titular"
                                data-aos="fade-in"
                                data-aos-duration="500"
                                data-aos-delay="50">
                                Packet Grup SL
                            </h1>
                            <h4 align="center" class="tense"
                                data-aos="fade-in"
                                data-aos-duration="500"
                                data-aos-delay="100">
                                {{ $t('inici[0].distribuidor')}}
                            </h4>
                        </div>
                    </div>
                </v-col>
                <v-row align="center" justify="center">
                </v-row>
            </v-row>
        </div>
      <!--   </v-parallax> -->
        
        <div class="fons-inici"></div>
      
        <v-row no-gutters class="slider-box">
            
        </v-row>
        <div class="container container-home">

            <blocs-inici />

            <v-row  class="mt-5 col-12 text-center">
                  <div class="title-home">     
                    <h1 >
                        {{ $t('inici[0].3raons')}}
                    </h1>
                </div>  
            </v-row>
            <v-row  class="mt-5 pb-5 mb-5">
                <v-col lg="4" sm="12" cols="12">
                    <div class="icon-box">
                        <p class="icon-image"
                            data-aos="zoom-in"
                            data-aos-duration="1000"
                            data-aos-delay="100"
                        >
                            <icon-base icon-name="Book" class="icon-home" height="32" width="32"><Book /></icon-base>
                        </p>
                        <div class="icon-box-text"
                            data-aos="fade-in"
                            data-aos-duration="1000"
                            data-aos-delay="100"
                            >
                            {{ $t('inici[0].1bloc') }} 
                        </div>
                    </div>
                </v-col>
                
                <v-col lg="4" sm="12" cols="12">
                    <div class="icon-box">
                        <p class="icon-image"
                            data-aos="zoom-in"
                            data-aos-duration="1300"
                            data-aos-delay="300"
                            >
                            <icon-base icon-name="Equalizer" class="icon-home" height="32" width="32"><Equalizer /></icon-base>
                        </p>
                        <div class="icon-box-text"
                            data-aos="fade-in"
                            data-aos-duration="1100"
                            data-aos-delay="600"
                        >
                            {{ $t('inici[0].2bloc') }}
                        </div>
                    </div>
                </v-col>

                <v-col lg="4" sm="12" cols="12">
                    <div class="icon-box">
                        <p class="icon-image"
                            data-aos="zoom-in"
                            data-aos-duration="1100"
                            data-aos-delay="300"
                            >
                            <icon-base icon-name="Note" class="icon-home" height="36" width="36"><Catalogue /></icon-base>
                        </p>
                        <div class="icon-box-text"
                            data-aos="fade-in"
                            data-aos-duration="1100"
                            data-aos-delay="200">
                            {{ $t('inici[0].3bloc') }}
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <div>
            
        </div>
        <div class="container-final">
            <v-row no-gutters class="padding-page">
                <v-col lg="7" sm="12" cols="12" class="finalPage-inici">
                        <h1 
                            data-aos="fade-in"
                            data-aos-duration="1000"
                            data-aos-delay="100">
                            {{ $t('inici[0].frasecontacte') }}
                        </h1>
                </v-col>

                <v-col lg="5">
                    <div class="btn-contact">
                        <div class="base-icon">
                            <icon-base icon-name="Note" class="icon-home" height="32" width="32"><Note /></icon-base>
                        </div>
                        <v-btn  
                            class="btn-pedido text-center text-white"
                            data-aos="fade-up"                            
                            data-aos-duration="1100"
                            data-aos-delay="600"
                            dark
                            rounded
                            center-active
                        >
                            <a :href="`/${$i18n.locale}/contacte`" class="nostyle">
                            {{ $t('inici[0].botopressupost') }}
                            </a>
                         </v-btn>
                    </div>
                </v-col>
                <v-col lg="1"></v-col>
            </v-row>
        </div>

        <!-- <carousel-inici /> -->
      <div class="finalPage"></div>
    </div>
</template>

<script>

const Note = () => import('@/assets/svg/Note.vue');
const Equalizer = () => import('@/assets/svg/Equalizer.vue');
const Book = () => import('@/assets/svg/Book.vue');
const Catalogue = () => import('@/assets/svg/Catalogue.vue');
const IconBase = () => import('@/components/elements/IconBase.vue');
const BlocsInici = () => import('@/components/elements/BlocsInici.vue');/* 
const CarouselInici = () => import('@/components/elements/CarouselInici.vue'); */


export default {
    name: 'Inici',
    metaInfo() {
        return { 
        metaInfo: {
            title: "Packet Grup SL material d'embalatge i logística.",
        },
        title: "Packet Grup SL material d'embalatge i logística.",
        description: "Packet Grup SL material d'embalatge i logística.",
        }
    },
    props: {
        msg: String
    },
    components: {
        Note,
        BlocsInici,
        IconBase,
        Equalizer,
        /* CarouselInici */
        Book,
        Catalogue
    },
    data () {
        return {
            items: [
                {
                    src:require('../../src/assets/images/embalatge-packetgrup.jpg'),
                    srcset:require('../../src/assets/images/embalatge-packetgrup.jpg'),
                },
                {
                    src:require('../../src/assets/images/fons-packetgrup-lateral.jpg'),
                    srcset:require('../../src/assets/images/fons-packetgrup.jpg'),
                },
                
            ],
        }
    },
    methods: {
    }
}

</script>

<style scoped lang="scss">

.margeInici {
    height: 80px;
}

.container-final {
    background: linear-gradient(-45deg, #ffa500, #ff6000);
}

.fons-inici {
    width: 100%;
    position: absolute;
}

.nostyle {
    color: white;
    text-decoration: none;
}

#Home {
    background: linear-gradient(180deg, #272727, rgb(39, 37, 37));
}

.icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    stroke-width: 0;

    &-box {
        color: white;
        margin: 20px 20px 40px 0;
        text-align: center;
        width: 100%;
        justify-content: center;
        border-color: rgb(255, 255, 255);
        display: flex;
        flex-flow: column wrap;
        align-items: center;

        &-text {
            background: rgb(255, 255, 255);
            padding: 30px;
            margin: 10px;
            border-radius: 15px;
            border: 5px solid #EA5F08;
            color: black;
            text-align: left;
            margin-top:10px;
            box-sizing: border-box;
            box-shadow: 6px 5px 7px #000000ba;
        }
    }

    &-home {
        color: #c5c6ab;
        color: white;
        width: 5em;
        height: 5em;
    }

    &-image {
        width: 8em;
        height: 8em;
        color: #c5c6ab;
        color: black;
        border: 5px solid #ff8f00;
        background: #ff8f00;
        border-radius: 50%;
    }
}

.icon-note {
    width: 8em;
    height: 8em;
}

p {    
    background: rgb(255, 255, 255);
    padding: 20px;
    border-radius: 15px;
    border: 10px solid rgb(241, 242, 215);
}

.text--center {
    text-align: center !important;
    justify-items: center;
}

.btn-contact {
    display: flex;
    flex-flow: row;
    justify-content: space-evenly;
    align-items: center;
    height: 100%;
}

.v-btn.btn-pedido:hover{
    color: white !important;
    background: #e66903;
}

.slider-box {
    margin-top: 0px;
}

.finalPage-inici {
   display:flex;
}

.image-home {
    border-radius: 5px;
}



</style>
